import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ContactFormPage } from './contact-form.page';

const routes: Routes = [
  {
    path: '',
    component: ContactFormPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class ContactFormPageRoutingModule {}
